import { TextCard } from 'shared/ui/cards/textCard';
import { MarginBottom } from './styles';
import { Fragment } from 'react/jsx-runtime';
import { FC } from 'react';
import { Order } from 'entities/orders';

export const OrderNotesInfo: FC<{ order: Order | null }> = ({ order }) => {
	return (
		<Fragment>
			{order && (
				<MarginBottom>
					{order?.notes && (
						<TextCard fitContent={false} mode='small' padding='8px 12px'>
							{order?.notes}
						</TextCard>
					)}
				</MarginBottom>
			)}
		</Fragment>
	);
};
